import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  developer: {
    display: 'flex',
    gap: '2px',
    justifyContent: 'center',
    alignItems: 'center',
    height: '32px',
    minWidth: '180px',
    width: '180px',
    padding: '12px 16px',
    borderRadius: '100px',
    background: 'rgba(108, 89, 230, 0.05)',
    color: '#6C59E6',
    fontSize: '12px',
    lineHeight: '16px',
    cursor: 'pointer',
    '&.changed': {
      background: 'rgba(108, 89, 230, 0.20)',
    },
    '&.selected': {
      background: '#6C59E633',
      border: '1px solid #6C59E6',
    },
    '& .title': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
}));
